'use strict';

var _ = require('lodash');
var MappedBookingsDirective = function MappedBookingsDirective() {
  return {
    restrict: 'E',
    template: require('../templates/mapped-bookings.html'),
    controller: 'MappedBookingsController',
    replace: true,
    scope: {
      entityData: '=',
      entities: '=',
      mode: '@',
      screen: '@',
      parentGridId: '@'
    },
    link: function link($scope) {
      $scope.$watch('mappedBookingsData', function () {
        $scope.showMessage = _.isEmpty($scope.mappedBookingsData);
      });
    }
  };
};
MappedBookingsDirective.$inject = [];
module.exports = MappedBookingsDirective;